import "./VisualizationLandingPage.css"
export function VisualizationLandingPage() {

  return (
    <div class="visLandingPage">
        <h1 id="visLandingHeading">Welcome!</h1>
        {<p id="visLandingBody">By exploring these results, you can discover how the preferences and decisions of growers and consultants 
        change depending on factors such as their region and choice of crop. <br></br> <br></br>Additionally, you can compare how your priorities and concerns align with other participants.
        <br></br> <br></br></p>}
        {<p id="visLandingBodyExtended">Click a question to learn more about California's farmers!</p>}
        
    </div>
    
    );
}